import { autorun, extendObservable, observe } from 'mobx';
import LogRocket from 'logrocket';

import { addToGlobalDataLayer, getSessionID } from '@ncl/modules/shared/globals/datalayer';

import { onCurrentUserChange } from './observers';

class AccountStore {
  constructor() {
    extendObservable(this, {
      policyholder: {},
      currentUser: {},
      tokenType: null,
      hasUser: false,
      referralCode: null,
      users: [],
    });

    observe(this, 'currentUser', change => {
      onCurrentUserChange(change, this);
    });

    autorun(() => {
      const { cgcCnpj } = this.policyholder;
      let trackId;

      if (cgcCnpj) {
        addToGlobalDataLayer('CNPJ', cgcCnpj);
        trackId = cgcCnpj;
      } else {
        trackId = getSessionID();
      }

      LogRocket.identify(trackId);
    });
  }
}

const accountStore = new AccountStore();

/* istanbul ignore next line */
if (process.env.NODE_ENV === 'development') window.accountStore = accountStore;

export default accountStore;
